import axios from './Axios';

export default class SagePay {
    /**
     * Load the SagePay JS library and execute the given callback.
     */
    static load(callback) {
        if (window.Sagepay !== undefined) {
            return callback();
        }

        let script = document.createElement('script');

        script.src = process.env.VUE_APP_SAGE_PAY_JS;
        script.onload = callback;
        script.onreadystatechange = function () {
            if (this.readyState === 'complete') {
                callback();
            }
        };

        document.getElementsByTagName('head')[0].appendChild(script);
    }

    /**
     * Get a merchant session key.
     */
    static async getMerchantSessionKey() {
        try {
            const response = await axios.get('v1/payment/merchant-session-key');

            if (response.status === 200 && !!response.data.merchantSessionKey) {
                let data = response.data;

                data.expiry = window.moment(data.expiry);

                return data;
            }
        } catch (error) {
            // Fall through.
        }
    }

    /**
     * Get a card identifier token and execute the given callback.
     */
    static getCardIdentifier(merchantSessionKey, cardholderName, cardNumber, expiryDate, securityCode, callback) {
        window.sagepayOwnForm({ merchantSessionKey }).tokeniseCardDetails({
            cardDetails: {
                cardholderName,
                cardNumber: cardNumber.match(/\d/g).join(''),
                expiryDate: expiryDate.match(/\d/g).join(''),
                securityCode
            },
            onTokenised: callback
        });
    }
}
